
<div class="nav-search-panel">
    <!-- Search field menu -->
    <v-menu offset-y v-model="fieldOpen" :close-on-content-click="false" max-width="400" >
        <template v-slot:activator="{ attrs, on }">
            <div class="nav-search-field" v-bind="attrs" v-on="on">
                <span>{{ search.field ? search.field.name : '' }}</span>
                <i class="fas fa-caret-down" :class="{'nav-search-field-open':fieldOpen}"></i>
            </div>
        </template>

        <div class="pa-3 white" v-if="fields && fields.length > 1" >
            <v-expansion-panels
                style="background-color: white; max-width: 300px"
            >
                <v-expansion-panel v-for="(category,index) in fields" :key="index">
                    <v-expansion-panel-header
                        style="min-height: 35px;">
                        {{ category.name }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-list-item class="pa-0  pt-1 pb-1" v-for="fld in category.fields" :key="fld.id" link @click="onFieldSelected(category.id, fld)">
                            <v-list-item-title class="pl-3 v-flex">
                                <div>
                                    {{ fld.name }}
                                </div>
                                <v-spacer />
                                <div class="nav-search-comment primary--text">
                                    {{ fld.comment }}
                                </div>
                            </v-list-item-title>
                        </v-list-item>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>

        <div class="white pb-3 pt-3" v-if="fields && fields.length === 1">
            <v-list-item class="pa-0  pt-1 pb-1" v-for="fld in fields[0].fields" :key="fld.id" link @click="onFieldSelected(fields[0].id, fld)">
                <v-list-item-title class="pl-3">
                    <div>
                        {{ fld.name }}
                    </div>
                    <div>
                    </div>
                </v-list-item-title>
            </v-list-item>
        </div>
    </v-menu>
    <!-- Search field menu -->

    <!-- Search criteria input -->
    <div class="nav-search-input" :class="error">
        <label>
            <input
                ref             = "searchinput"
                @keypress.enter = "onEnter"
                @focusin        = "onFocusIn"
                @focusout       = "onFocusOut"
                type            = "text"
                v-model         = "search.criteria"
                @keydown        = "onKeydown"
                @keyup          = "onKeyup"
            />
        </label>
        <div class="nav-search-icon">
            <a @click="onSearch"><i class="fas fa-search"></i></a>
        </div>
    </div>
    <!-- Search criteria input -->

    <div v-if="search.field && search.field.category === 'site'">
        <c-app-unit-filter
            @change = "onChangeFilter"
        />
    </div>

    <div v-if="search.field && search.field.category === 'incident'">
        <c-app-incident-filter
            @change = "onChangeFilter"
        />
    </div>

    <!-- Hits count popup -->
    <div 
        class="nav-search-hit-panel secondary white--text" 
        v-if="showHits" 
        @click="onSearch"
        @mousedown.prevent
        style="cursor: pointer;"
    >
        <span>{{ hits }}{{ i18n ("hits") }}</span>
    </div>
    <!-- Hits count popup -->

</div>
